import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import GlobalTicker from "@/components/GlobalTicker";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Contracts from "@/pages/Contracts";
import AOG from "@/pages/AOG";
import Marketplace from "@/pages/Marketplace";
import Forum, { TopicView } from "@/pages/Forum";
import AeroIntel from "@/pages/AeroIntel";
import Profile from "@/pages/Profile";
import Inbox from "@/pages/Inbox";
import Membership from "@/pages/Membership";
import AddonUpsell from "@/pages/AddonUpsell";
import VerifyFlightAttendant from "@/pages/VerifyFlightAttendant";
import VerifyIdentity from "@/pages/VerifyIdentity";
import AdminFaVerifications from "@/pages/AdminFaVerifications";
import AdminMigration from "@/pages/AdminMigration";
import AdminLegacyMigration from "@/pages/AdminLegacyMigration";
import LegacyWelcome from "@/pages/LegacyWelcome";
import ClaimLegacy from "@/pages/ClaimLegacy";
import UpgradeGateModal from "@/components/UpgradeGateModal";
import IdentityGateModal from "@/components/IdentityGateModal";
import { DirectoryHub, DirectoryCategory } from "@/pages/Directory";
import DigitalID from "@/pages/DigitalID";
import Contact from "@/pages/Contact";
import Dashboard from "@/pages/Dashboard";
import Cockpit from "@/pages/Cockpit";
import InstantQuote from "@/pages/InstantQuote";
import EmptyLegProgram from "@/pages/EmptyLegProgram";
import CharterMembership from "@/pages/CharterMembership";
import CharterClientDashboard from "@/pages/CharterClientDashboard";
import OperatorFuelPrices from "@/pages/OperatorFuelPrices";
import AuthCallback from "@/pages/AuthCallback";
import Logbook from "@/pages/Logbook";
import PHF from "@/pages/PHF";
import PaymentSuccess from "@/pages/PaymentSuccess";
import RiderDashboard from "@/pages/RiderDashboard";
import RiderTSA from "@/pages/RiderTSA";
import PaymentCancel from "@/pages/PaymentCancel";
import PilotSearch from "@/pages/PilotSearch";
import CrewProfile from "@/pages/CrewProfile";
import HireCrewNow from "@/pages/HireCrewNow";
import HireCardSaved from "@/pages/HireCardSaved";
import Operators from "@/pages/Operators";
import OperatorDetail from "@/pages/OperatorDetail";
import OperatorOnboard from "@/pages/OperatorOnboard";
import CharterRequest from "@/pages/CharterRequest";
import CharterRequestDetail from "@/pages/CharterRequestDetail";
import CharterRequestList from "@/pages/CharterRequestList";
import AirportDetail from "@/pages/AirportDetail";
import Wallet from "@/pages/Wallet";
import DigitalId from "@/pages/DigitalId";
import DigitalIdDemo from "@/pages/DigitalIdDemo";
import SocialFeed from "@/pages/SocialFeed";
import Unicom from "@/pages/Unicom";
import Fuel from "@/pages/Fuel";
import Admin from "@/pages/Admin";
import AircraftSales from "@/pages/AircraftSales";
import Documents from "@/pages/Documents";
import AccountSettings from "@/pages/AccountSettings";
import { Privacy, Terms, SubscriptionTerms, RefundPolicy, CookiePolicy } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <UpgradeGateModal />
        <IdentityGateModal />
        <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#121C26", border: "1px solid rgba(0,240,255,0.25)", color: "#F8FAFC", fontFamily: "'JetBrains Mono', monospace", fontSize: "12px" } }} />
        <Header />
        <GlobalTicker />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/directory" element={<DirectoryHub />} />
          <Route path="/directory/:category" element={<DirectoryCategory />} />
          <Route path="/aerointel" element={<AeroIntel />} />
          <Route path="/digital-id" element={<DigitalID />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/dashboard" element={<Cockpit />} />
          <Route path="/jobs" element={<Contracts />} />
          <Route path="/contracts" element={<Contracts />} />
          <Route path="/aog" element={<AOG />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/forum" element={<Forum />} />
          <Route path="/forum/:tid" element={<TopicView />} />
          <Route path="/ai" element={<AeroIntel />} />
          <Route path="/profile" element={<Cockpit />} />
          <Route path="/inbox" element={<Inbox />} />
          <Route path="/logbook" element={<Logbook />} />
          <Route path="/phf" element={<PHF />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/membership/addon" element={<AddonUpsell />} />
          <Route path="/verify/flight-attendant" element={<VerifyFlightAttendant />} />
          <Route path="/verify/identity" element={<VerifyIdentity />} />
          <Route path="/admin/fa-verifications" element={<AdminFaVerifications />} />
          <Route path="/admin/migration" element={<AdminMigration />} />
          <Route path="/admin/legacy-migration" element={<AdminLegacyMigration />} />
          <Route path="/welcome/:token" element={<LegacyWelcome />} />
          <Route path="/claim" element={<ClaimLegacy />} />
          <Route path="/rider/dashboard" element={<RiderDashboard />} />
          <Route path="/rider" element={<RiderDashboard />} />
          <Route path="/rider/tsa" element={<RiderTSA />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/search" element={<PilotSearch />} />
          <Route path="/find-crew" element={<PilotSearch />} />
          <Route path="/crew/:userId" element={<CrewProfile />} />
          <Route path="/hire-now" element={<HireCrewNow />} />
          <Route path="/hire-now/card-saved" element={<HireCardSaved />} />
          <Route path="/hire-now/card-cancelled" element={<HireCrewNow />} />
          <Route path="/operators" element={<Operators />} />
          <Route path="/operators/onboard" element={<OperatorOnboard />} />
          <Route path="/operators/fuel-prices" element={<OperatorFuelPrices />} />
          <Route path="/operators/:id" element={<OperatorDetail />} />
          <Route path="/charter-request" element={<CharterRequest />} />
          <Route path="/quote" element={<InstantQuote />} />
          <Route path="/empty-leg" element={<EmptyLegProgram />} />
          <Route path="/charter-membership" element={<CharterMembership />} />
          <Route path="/charter-dashboard" element={<CharterClientDashboard />} />
          <Route path="/charter-requests" element={<CharterRequestList />} />
          <Route path="/charter-requests/:id" element={<CharterRequestDetail />} />
          <Route path="/airports/:icao" element={<AirportDetail />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/id/:token" element={<DigitalId />} />
          <Route path="/digital-id/demo" element={<DigitalIdDemo />} />
          <Route path="/feed" element={<SocialFeed />} />
          <Route path="/unicom" element={<Unicom />} />
          <Route path="/fuel" element={<Fuel />} />
          <Route path="/aircraft-sales" element={<AircraftSales />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/settings/account" element={<AccountSettings />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/subscription-terms" element={<SubscriptionTerms />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </AuthProvider>
  );
}
